import { render, staticRenderFns } from "./StaffOrderingFilter.vue?vue&type=template&id=47967965"
import script from "./StaffOrderingFilter.vue?vue&type=script&lang=ts"
export * from "./StaffOrderingFilter.vue?vue&type=script&lang=ts"
import style0 from "./StaffOrderingFilter.vue?vue&type=style&index=0&id=47967965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports